<!--
 * @Author: wh
 * @Date: 2020-07-02 20:00:52
 * @LastEditTime: 2022-10-20 17:19:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\retailAccount\retailAccountMaintain.vue
-->
<template>
    <div class="retailAccountMaintain">
        <van-nav-bar
            title="维护"
            left-arrow
            @click-left="onClickLeft"
            @click-right="onClickRight"
            class="new"
        >
            <template #right>
                <span class="iconfont iconicon-test"></span>
            </template>
        </van-nav-bar>
        <div class="warpper">
            <ul v-if="maintenanceList.length>0">
                <li v-for="item in maintenanceList" :key="item.crmid">
                    <div class="status status-bf">
                        {{ item.maintenance_type_name }}
                    </div>
                    <div class="item item-fl">
                        <div class="tit">
                            {{ item.capacity }}
                        </div>
                        <div class="describe">
                            方量(方)
                        </div>
                    </div>
                    <div class="item item-je">
                        <div class="tit">
                            {{ item.amount_money }}
                        </div>
                        <div class="describe">
                            金额(元)
                        </div>
                    </div>
                    <div class="item item-paytype">
                        <div class="tit">
                            {{ item.payment_mode_name }}
                        </div>
                        <div class="describe">
                            支付方式
                        </div>
                    </div>
                </li>
            </ul>
            <div class="no-data" v-else></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'retail-account-maintain',
    components: {},
    props: {},
    data() {
        return {
            // 合同版本id
            cvid: '',
            // 维护记录列表
            maintenanceList: [],
        };
    },
    watch: {},
    computed: {},
    activated() {
        this.cvid = this.$route.params.cvid;
        this.getMaintenanceList();
    },
    methods: {
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/retailAccountList' });
        },
        // 新增维护
        onClickRight() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'newMaintain', params: { cvid: this.cvid } });
        },
        // 获取零售合同维护记录列表
        getMaintenanceList() {
            this.$axios
                .post('/interfaceApi/sale/contract_manager/get_maintenance_list/' + this.cvid)
                .then(res => {
                    if (res) {
                        this.maintenanceList = res;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
    },
    created() {},
    mounted() {
        this.cvid = this.$route.params.cvid;
        this.getMaintenanceList();
    },
};
</script>
<style lang="stylus" scoped>
.retailAccountMaintain
    width 100%
    .new
        .iconicon-test
            color #fff
    .warpper
        height 100%
        overflow-y auto
        overflow-x hidden
        background #F0F0F0
        padding 15rpx
        li
            width 100%
            margin-bottom 15rpx
            border-radius 5rpx
            height 50rpx
            background #fff
            display flex
            justify-content space-between
            .status
                width 50rpx
                height 100%
                position relative
                color #fff
                border-radius 5rpx 0 0 5rpx
                text-align center
                font-size 14rpx
                line-height 50rpx
                &:before
                    content ' '
                    position absolute
                    right -16rpx
                    width 0
                    height 0
                    top 17rpx
                    border-right 8rpx solid transparent
                    border-left 8rpx solid #3E67C6
                    border-bottom 8rpx solid transparent
                    border-top 8rpx solid transparent
            .item
                text-align center
                padding-top 6rpx
                margin 0 10rpx
                .describe
                    color #979EA7
                    font-size 10rpx
                .tit
                    font-size 16rpx
                    white-space nowrap
                    overflow hidden
                    text-overflow ellipsis
                    margin-bottom 3rpx
                    height 20rpx
                    line-height 20rpx
            .status-bf
                background #3E67C6
            .item-fl
                .tit
                    color #3E67C6
            .item-je
                .tit
                    color #FC8311
            .item-paytype
                .tit
                    color #061F3E


</style>